var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10876",
    "data-name": "Group 10876",
    transform: "translate(0 -0.249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4191",
    "data-name": "Rectangle 4191",
    width: 54,
    height: 53,
    transform: "translate(0 0.249)",
    fill: "#b52018",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44738",
    "data-name": "Path 44738",
    d: "M26.629,18.1a8.531,8.531,0,1,0,8.531,8.531A8.539,8.539,0,0,0,26.629,18.1m25.629,8.531c0-3.551,0-7.03-.183-10.581-.183-4.1-1.135-7.762-4.137-10.727-3-3-6.627-3.954-10.727-4.137C33.658,1,30.18,1,26.629,1s-7.03,0-10.581.183c-4.1.183-7.762,1.135-10.727,4.137-3,3-3.954,6.627-4.137,10.727C1,19.6,1,23.077,1,26.629s0,7.03.183,10.581c.183,4.1,1.135,7.762,4.137,10.727,3,3,6.627,3.954,10.727,4.137,3.551.183,7.03.183,10.581.183s7.03,0,10.581-.183c4.1-.183,7.762-1.135,10.727-4.137,3-3,3.954-6.627,4.137-10.727.22-3.515.183-7.03.183-10.581M26.629,39.772A13.144,13.144,0,1,1,39.772,26.629,13.11,13.11,0,0,1,26.629,39.772M40.322,16.011A3.075,3.075,0,1,1,43.4,12.936a3,3,0,0,1-3.039,3.039Z",
    transform: "translate(0.349 0.619)",
    fill: "#b52018"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaHover);
export default __webpack_public_path__ + "static/media/insta-hover.409097b93cd3a12078ad67b4e5681b6e.svg";
export { ForwardRef as ReactComponent };